import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AdminCognitoService } from '../services/admin-cognito.service';

/**
 * Allows the route only for `custom:user_type === 'CONTRACTOR'` Cognito users.
 * Mirrors `AdminGuard` shape; relies on `AdminCognitoService` because that's
 * the service the existing guards already use to read the current user.
 *
 * NOTE: the FE convention in this codebase is uppercase (`CONTRACTOR`) per
 * `home.component.ts` / `app.component.ts` — even though the BE checks the
 * lowercase form server-side. Both forms exist in production today.
 */
@Injectable({
  providedIn: 'root',
})
export class ContractorGuard {
  constructor(
    private router: Router,
    private cognitoService: AdminCognitoService
  ) {}

  async canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    const isAuth = await this.cognitoService.isAuthenticated();
    if (!isAuth) {
      this.router.navigateByUrl('/signIn');
      return false;
    }

    let userType: string | undefined;
    try {
      const user = await this.cognitoService.getUser();
      userType = user?.attributes?.['custom:user_type'];
    } catch {
      userType = undefined;
    }

    if (userType !== 'CONTRACTOR') {
      this.router.navigateByUrl('/home');
      return false;
    }

    return true;
  }
}
